import { addDoc, collection, doc, setDoc } from "firebase/firestore";
import React, { useContext, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button, Heading } from "../../components";
import { CheckCircle } from "../../components/Icons/Icons";
import { UserContext } from "../../contexts/userContext";
import { db } from "../../firebase";
import styles from "./styles.module.css";

function VerifyPayment() {
  const navigate = useNavigate();
  const { user, userLoading } = useContext(UserContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const payment_id = searchParams.get("?payment_id"); // "?" is required in front of payment_id, dont remove
  const plan = searchParams.get("plan");
  const months = searchParams.get("months");
  const amount = searchParams.get("amount");

  useEffect(() => {
    if (!userLoading) {
      if (user && payment_id) {
        storePayment();
      } else {
        navigate("/");
      }
    }
  }, [user, userLoading]);

  const storePayment = async () => {
    const payload = {
      paymentId: payment_id,
      user: user.uid,
      createdAt: new Date(),
      planName: plan,
      amount: amount,
    };
    await updateUserProfile();
    await addDoc(collection(db, "payments"), payload);
  };

  const updateUserProfile = async () => {
    const { uid } = user;
    const today = new Date();
    await setDoc(
      doc(db, "users", uid),
      {
        paid: true,
        payment_id,
        payment_date: new Date(),
        end_date: new Date(today.setMonth(today.getMonth() + parseInt(months))),
      },
      { merge: true }
    );
  };

  return (
    <div className={styles.verifyPayment}>
      <CheckCircle width={100} height={100} />
      <h1 className={styles.heading}>Payment Successful</h1>
      <div style={{ width: "100%" }}>
        <table className={styles.table}>
          <tr>
            <td>Payment Id: </td>
            <td> {payment_id}</td>
          </tr>
          <tr>
            <td>User Email: </td>
            <td>{user?.email}</td>
          </tr>
          <tr>
            <td>Plan</td>
            <td style={{ textTransform: "capitalize" }}>{plan}</td>
          </tr>
          <tr>
            <td>Amount</td>
            <td>&#8377; {amount}</td>
          </tr>
        </table>
      </div>
      <div className={styles.desc}>
        <div style={{ marginBottom: "0.5em" }}>
          Sometimes it takes a little while for payment status to be confirmed.
        </div>
        <div>
          To speed up the process, please share a screenshot of this page in the chat below.
        </div>
      </div>
      <p>Make your resume shine!</p>
      <br />
      <div>
        <Button
          content="Go to Homepage"
          // style={{ marginRight: "2em" }}
          onClick={() => {window.location.replace("/me")}}
        />
      </div>
    </div>
  );
}

export default VerifyPayment;
